var map = {
	"./computerscience/post/1.jpg": 3846,
	"./computerscience/post/1.webp": 28426,
	"./computerscience/post/2.jpg": 7603,
	"./computerscience/post/2.webp": 56040,
	"./computerscience/post/3.jpg": 77047,
	"./computerscience/post/3.webp": 43728,
	"./computerscience/post/4.jpg": 15929,
	"./computerscience/post/4.webp": 77316,
	"./computerscience/post/computerscience-post.zip": 81588,
	"./computerscience/story/1.jpg": 91324,
	"./computerscience/story/1.webp": 50518,
	"./computerscience/story/2.jpg": 72492,
	"./computerscience/story/2.webp": 33633,
	"./computerscience/story/3.jpg": 96590,
	"./computerscience/story/3.webp": 95980,
	"./computerscience/story/4.jpg": 717,
	"./computerscience/story/4.webp": 15639,
	"./computerscience/story/computerscience-story.zip": 59703,
	"./mathematics/post/1.jpg": 77636,
	"./mathematics/post/1.webp": 76942,
	"./mathematics/post/2.jpg": 91333,
	"./mathematics/post/2.webp": 40714,
	"./mathematics/post/3.jpg": 98633,
	"./mathematics/post/3.webp": 88048,
	"./mathematics/post/4.jpg": 15137,
	"./mathematics/post/4.webp": 96546,
	"./mathematics/post/mathematics-post.zip": 9911,
	"./mathematics/story/1.jpg": 79439,
	"./mathematics/story/1.webp": 69122,
	"./mathematics/story/2.jpg": 45960,
	"./mathematics/story/2.webp": 28709,
	"./mathematics/story/3.jpg": 96997,
	"./mathematics/story/3.webp": 99002,
	"./mathematics/story/4.jpg": 60067,
	"./mathematics/story/4.webp": 38974,
	"./mathematics/story/mathematics-story.zip": 66591,
	"./statistics/post/1.jpg": 16795,
	"./statistics/post/1.webp": 644,
	"./statistics/post/2.jpg": 47435,
	"./statistics/post/2.webp": 80712,
	"./statistics/post/3.jpg": 25956,
	"./statistics/post/3.webp": 9040,
	"./statistics/post/4.jpg": 50577,
	"./statistics/post/4.webp": 72988,
	"./statistics/post/statistics-post.zip": 5012,
	"./statistics/story/1.jpg": 88385,
	"./statistics/story/1.webp": 85775,
	"./statistics/story/2.jpg": 95201,
	"./statistics/story/2.webp": 53745,
	"./statistics/story/3.jpg": 52001,
	"./statistics/story/3.webp": 71497,
	"./statistics/story/4.jpg": 79319,
	"./statistics/story/4.webp": 5294,
	"./statistics/story/statistics-story.zip": 17455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63684;